import React, { memo } from "react";

interface SidebarToggleProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

const SidebarToggle: React.FC<SidebarToggleProps> = memo(({ isCollapsed, onToggle }) => {
  return (
    <button
      className="collapse-toggle"
      onClick={onToggle}
      title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
      aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
    >
      <span className="toggle-icon">{isCollapsed ? "←" : "→"}</span>
    </button>
  );
});

SidebarToggle.displayName = "SidebarToggle";

export default SidebarToggle;
